export default "__VITE_ASSET__Uk2AJeYk__"